import { deletePullet } from "../pullet/actions";
import {
  PULLET_INVENTORY_DELETE_FAIL,
  PULLET_INVENTORY_DELETE_REQUEST,
} from "../pullet/actionType";
import axios from "./utils/axios";

const fetchDeletePullet = (inventory_id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PULLET_INVENTORY_DELETE_REQUEST });
      const {
        login: { userInfo },
      } = getState();
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.delete(
        `api/pullet/delete-inventory/${inventory_id}/`,
        config
      );
      dispatch(deletePullet(data));
    } catch (error) {
      dispatch({
        type: PULLET_INVENTORY_DELETE_FAIL,
        payload:
          error.response && error.response.data.details
            ? error.response.data.details
            : error.message,
      });
    }
  };
};
export default fetchDeletePullet;
